// src/components/Layout.jsx
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth, tieneAcceso } from '../context/AuthContext';

export default function Layout({ children }) {
  const { usuario, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => { logout(); navigate('/'); };

  const links = [
    { path: '/dashboard',  label: '📊 Dashboard'  },
    { path: '/ventasdashboard', label: '📊 Ventas Dashboard'  },
    { path: '/tareas', label: '📋 Tareas Zoler'  },
    { path: '/ordenes',    label: '📋 Órdenes'     },
    { path: '/consulta',   label: '🔍 Consulta'    },
    { path: '/productos',  label: '📦 Productos'   },
    { path: '/inventario', label: '🏭 Inventario'  },
    { path: '/garantiasmodule', label: '🔋 Baterias' },
    { path: '/vehiculos', label: '🚗 Vehículos' },
    { path: '/auditoria',  label: '🔍 Auditoría'   },
    { path: '/reposicion', label: '🧠 Reposición'  },
    { path: '/clientes',   label: '👥 Clientes'    },
    { path: '/creditos', label: '💳 Créditos' },
    { path: '/proveedores',label: '🏭 Proveedores' },
    { path: '/bodegas', label: '🏭 Bodegas' },
    { path: '/finanzas',   label: '💰 Finanzas'    },
    { path: '/facturas',   label: '📄 Facturas'    },
    { path: '/banco',      label: '🏦 Banco'      },
    { path: '/empleados', label: '👤 Empleados'  },
    { path: '/cierrecaja', label: '💰 Cierre Caja'  },

  ].filter(l => tieneAcceso(usuario?.rol, l.path));

  const ROL_BADGE = {
    admin:      { label: 'Admin',      color: '#4cc9f0' },
    supervisor: { label: 'Supervisor', color: '#ffc107' },
  };
  const badge = ROL_BADGE[usuario?.rol] || { label: usuario?.rol, color: '#aaa' };

  return (
    <div style={s.container}>
      <aside style={s.sidebar}>
        <div style={s.logo}>🔧 Zoler</div>
        <nav style={s.nav}>
          {links.map(l => (
            <Link
              key={l.path}
              to={l.path}
              style={{...s.navLink, ...(location.pathname === l.path ? s.navLinkActivo : {})}}
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <div style={s.footer}>
          <p style={s.usuario}>👤 {usuario?.nombre}</p>
          <span style={{ ...s.rolBadge, color: badge.color, borderColor: badge.color }}>
            {badge.label}
          </span>
          <button style={s.botonSalir} onClick={handleLogout}>Cerrar sesión</button>
        </div>
      </aside>
      <main style={s.main}>{children}</main>
    </div>
  );
}

const s = {
  container:    { display: 'flex', minHeight: '100vh', background: '#0f0f1a' },
  sidebar:      { width: 220, background: '#1e1e2e', display: 'flex', flexDirection: 'column', padding: '24px 16px' },
  logo:         { color: '#fff', fontSize: 22, fontWeight: 'bold', marginBottom: 40 },
  nav:          { display: 'flex', flexDirection: 'column', gap: 8, flex: 1 },
  navLink:      { color: '#aaa', textDecoration: 'none', padding: '10px 16px', borderRadius: 8, fontSize: 14 },
  navLinkActivo:{ background: '#2d2d44', color: '#fff' },
  footer:       { borderTop: '1px solid #2d2d44', paddingTop: 16, display: 'flex', flexDirection: 'column', gap: 8 },
  usuario:      { color: '#aaa', fontSize: 13, margin: 0 },
  rolBadge:     { fontSize: 11, fontWeight: 'bold', border: '1px solid', borderRadius: 6, padding: '2px 10px', textAlign: 'center' },
  botonSalir:   { background: 'none', border: '1px solid #e63946', borderRadius: 8, color: '#e63946', padding: '8px 12px', cursor: 'pointer', width: '100%', fontSize: 13 },
  main:         { flex: 1, padding: 32, overflowY: 'auto' },
};